/* LOGIXA homepage content — KZ. Shape must match de.ts exactly. */

export const kz = {
  nav: {
    links: [
      { label: 'Өнім', href: '#plattform' },
      { label: 'Шешімдер', href: '#disposition' },
      { label: 'Интеграциялар', href: '#integrationen' },
      { label: 'Бағалар', href: '#preise' },
      { label: 'Ресурстар', href: '/docs' },
    ],
    login: 'Кіру',
    demo: 'Демо сұрау',
    menu: 'Мәзір',
  },

  hero: {
    kicker: 'TRANSPORT MANAGEMENT SYSTEM',
    h1: 'Тек диспетчерлеу жеткіліксіз көлік компанияларына арналған TMS жүйесі.',
    sub: 'Тапсырыстар, диспетчерлеу, жүргізушілер, автопарк, GPS, құжаттар және есеп айырысу бір платформада. LOGIXA бүкіл көлік ұйымын байланыстырады — тапсырыстан шот-фактураға дейін.',
    primary: 'Демо сұрау',
    secondary: 'Демо көру',
    trust: ['GDPR талаптарына сай', 'Германиядағы хостинг', '9 тіл', '12 күнде іске қосу'],
    demoNote: 'Демонстрациялық деректер',
  },

  mock: {
    search: 'Іздеу…',
    user: 'Max Mustermann',
    role: 'ADMIN',
    nav: ['Шолу', 'Тапсырыстар', 'Диспетчерлеу', 'Көлік', 'Жүргізушілер', 'Рейс жоспарлау', 'GPS бақылау', 'Құжаттар', 'Хабарламалар', 'Есептер', 'Есеп айырысу', 'Баптаулар'],
    live: 'LIVE',
    card: {
      id: 'FLEET-DEMO-118',
      route: 'Гамбург, DE → Роттердам, NL',
      etaLbl: 'ETA',
      eta: 'Бүгін, 14:30',
      driverLbl: 'ЖҮРГІЗУШІ',
      driver: 'John D.',
      progress: 64,
    },
    ordersTitle: 'Белсенді тапсырыстар',
    orders: [
      { id: 'FLEET-DEMO-118', state: 'ЖОЛДА', tone: 'go' },
      { id: 'FLEET-DEMO-117', state: 'ЖОЛДА', tone: 'go' },
      { id: 'FLEET-DEMO-116', state: 'ТИЕУ', tone: 'load' },
      { id: 'FLEET-DEMO-115', state: 'ЖОСПАРЛАНҒАН', tone: 'plan' },
      { id: 'FLEET-DEMO-114', state: 'АЯҚТАЛҒАН', tone: 'done' },
    ],
    kpiTitle: 'Бүгінгі KPI',
    kpis: [
      { lbl: 'ТАПСЫРЫСТАР', val: '850', delta: '+14 %' },
      { lbl: 'БОС ЖҮРІС', val: '14 %', delta: '−16 %' },
      { lbl: 'ТҮСІМ', val: '€92K', delta: '+18 %' },
    ],
    statusTitle: 'Көлік күйі',
    status: [
      { n: '104', lbl: 'ЖОЛДА' },
      { n: '18', lbl: 'ТИЕУ' },
      { n: '7', lbl: 'ТҮСІРУ' },
      { n: '4', lbl: 'ЖӨНДЕУ' },
      { n: '2', lbl: 'БЕЛСЕНДІ ЕМЕС' },
    ],
    plates: [
      { p: 'HH-LOG 33', tone: 'go' },
      { p: 'B-KT 155', tone: 'acc' },
      { p: 'K-AB 147', tone: 'idle' },
    ],
  },

  integrations: {
    label: 'Қолданыстағы логистикалық\nинфрақұрылымға интеграция',
    items: ['TIMOCOM', 'Trans.eu', 'DATEV', 'Stripe', 'SEPA', 'n8n', 'Make', 'Zapier'],
  },

  platform: {
    kicker: 'ПЛАТФОРМА',
    h2: 'Сіздің компанияңыз. Бір жүйе.',
    sub: 'Excel кестелері жоқ. Жүргізушілерге, GPS-ке және есеп айырысуға арналған бөлек жүйелер жоқ. Бес құралдан ақпарат іздеу жоқ.',
    areas: [
      {
        n: '01',
        title: 'Тапсырыстар және диспетчерлеу',
        desc: 'Тапсырыстарды енгізу, жүргізушілер мен көлікті тағайындау, рейстерді жоспарлау және тасымал күйін нақты уақытта бақылау.',
        chips: ['Тапсырыстар', 'AI диспетчер', 'Жоспарлау', 'ePOD'],
      },
      {
        n: '02',
        title: 'Автопарк және GPS',
        desc: 'Көлікті онлайн бақылау, техқызметті жоспарлау, TCO қадағалау және геоаймақтарды басқару.',
        chips: ['Live GPS', 'TCO', 'Техқызмет', 'Геоаймақ'],
      },
      {
        n: '03',
        title: 'Жүргізушілер және сәйкестік',
        desc: 'Жұмыс уақыты, құжаттар, тахограф және EU 561 ережелері бір жерде — мерзімдер мәселеге айналмай тұрып.',
        chips: ['Тахограф', 'EU 561', 'ADR', '95-модуль'],
      },
      {
        n: '04',
        title: 'Есеп айырысу және қаржы',
        desc: 'Жалақы, үстемеақы, төлемдер және DATEV процестері тасымалдың операциялық деректерімен тікелей байланысады.',
        chips: ['Payroll', 'DATEV', 'SEPA', 'Stripe'],
      },
    ],
    cta: 'Барлық мүмкіндіктерді көру',
  },

  dispatch: {
    kicker: 'АҚЫЛДЫ ДИСПЕТЧЕРЛЕУ',
    h2: 'Ойлайтын диспетчерлеу.',
    sub: 'LOGIXA жүргізушілерді, көлікті, жүргізу уақытын, қолжетімділікті және маршрутты ескеріп, диспетчерге оңтайлы тағайындауды таңдауға көмектеседі.',
    points: [
      { title: 'AI диспетчер', desc: 'Тапсырысқа сай жүргізуші мен көлікті ұсынады.' },
      { title: 'Маршрутты оңтайландыру', desc: 'Жол ақысын, қашықтықты, жүргізу уақытын және отынды ескереді.' },
      { title: 'Diesel Intelligence', desc: 'Маршрут бойындағы ағымдағы отын бағасына қарай жанармай құюды жоспарлайды.' },
    ],
    panelTitle: 'Маршрут ұсынысы',
    metrics: [
      { lbl: 'Қашықтық', val: '1 346 км' },
      { lbl: 'Жүру уақыты', val: '17 сағ 25 мин' },
      { lbl: 'Жол ақысы', val: '€ 128,40' },
      { lbl: 'CO₂', val: '1 245 кг' },
    ],
    stopsTitle: 'Ұсынылған жанармай бекеттері',
    live: 'LIVE',
    stops: [
      { city: 'Ганновер', price: '€ 1,59', best: false },
      { city: 'Кассель', price: '€ 1,58', best: false },
      { city: 'Франкфурт', price: '€ 1,55', best: true },
      { city: 'Вюрцбург', price: '€ 1,62', best: false },
    ],
    apply: 'Маршрутты қабылдау',
    source: 'Баға көздері: Tankerkönig (DE), prix-carburants (FR), E-Control (AT), MITECO (ES)',
  },

  driver: {
    kicker: 'ЖҮРГІЗУШІ ҚОСЫМШАСЫ',
    h2: 'Жүргізушінің бәрі қасында.',
    sub: 'iOS және Android үшін нативті қосымшалар — тапсырыстан қолтаңбаға дейінгі толық рейс циклі, желісіз де жұмыс істейді.',
    flow: ['Тапсырыс алу', 'Навигацияны қосу', 'Құжаттарды сканерлеу', 'ePOD қолтаңбасы', 'Рейсті жабу'],
    chips: ['iOS', 'Android', 'Офлайн режим', 'Telegram бот', '9 тіл'],
    phones: [
      {
        tag: 'ТАПСЫРЫС #DE-1107',
        title: 'Гамбург → Роттердам',
        rows: [
          { lbl: 'ТИЕУ', val: 'Бүгін 08:30' },
          { lbl: 'ЖЕТКІЗУ', val: 'Бүгін 14:30' },
          { lbl: 'КӨЛІК', val: 'HH-LOG 33' },
          { lbl: 'ЖҮК', val: '18 палет · 12,4 т' },
        ],
        action: 'Навигацияны қосу',
      },
      {
        tag: 'ҚҰЖАТТАР',
        title: 'CMR сканерлеу',
        rows: [
          { lbl: 'ЖҮКҚҰЖАТ', val: 'CMR-2026-4471' },
          { lbl: 'КҮЙІ', val: 'Сканерленді · 2 бет' },
          { lbl: 'ҚАБЫЛДАУ АКТІСІ', val: 'Күтілуде' },
        ],
        action: 'Сканды жүктеу',
      },
      {
        tag: 'ePOD',
        title: 'Қабылдауды растау',
        rows: [
          { lbl: 'АЛУШЫ', val: 'De Vries Logistics BV' },
          { lbl: 'ҚОЛТАҢБА', val: 'Алынды' },
          { lbl: 'ФОТО', val: '3 тіркеме' },
        ],
        action: 'Рейсті жабу',
      },
    ],
  },

  compliance: {
    kicker: 'СӘЙКЕСТІК ЖӘНЕ ҚАУІПСІЗДІК',
    h2: 'Жүргізу уақытын мәселеге айналмай тұрып көріңіз.',
    sub: 'Жүргізу мен демалыс уақыты, тахограф деректері және мерзімі бітетін құжаттар бір жерде — әрекет етуге уақыт бар кезде ескертумен.',
    points: [
      { title: 'EU 561', desc: 'Әр жүргізуші бойынша ағымдағы жүргізу және демалыс уақыты, үздіксіз салыстырылады.' },
      { title: 'Тахограф', desc: 'DDD файлдарын импорттау және жүргізуші деректерін бақылау.' },
      { title: 'Құжаттар', desc: 'Куәлік, ADR және 95-модуль мерзімі бітер алдында ескерту.' },
    ],
    dashDriverLbl: 'Жүргізуші',
    dashDriver: 'John D.',
    badge: 'СӘЙКЕС',
    bars: [
      { lbl: 'Бүгінгі жүргізу', val: '7 сағ 45 / 9 сағ', pct: 86, tone: 'warn' },
      { lbl: 'Апталық жүргізу', val: '38 сағ 10 / 56 сағ', pct: 68, tone: 'ok' },
      { lbl: 'Келесі демалыс', val: '1 сағ 15 мин ішінде', pct: 42, tone: 'ok' },
    ],
    docsTitle: 'Мерзімі бітетін құжаттар',
    docs: [
      { lbl: 'Жүргізуші куәлігі', val: '12.03.2027', warn: false },
      { lbl: 'ADR сертификаты', val: '18.05.2027', warn: true },
      { lbl: '95-модуль', val: '22.09.2027', warn: false },
    ],
    alerts: '3 БЕЛСЕНДІ ЕСКЕРТУ',
  },

  onboarding: {
    kicker: 'КӨШУ',
    h2: 'Әлі Excel ме? Мәселе емес.',
    sub: 'Жүргізушілерді, көлікті және контрагенттерді Excel, CSV немесе қазіргі TMS жүйеңізден көшіреміз.',
    promoTitle: '12 күнде іске қосу.',
    promoSub: 'Жылдам. Сенімді. Тәуекелсіз.',
    promoCta: 'Демо сұрау',
    steps: [
      { tag: '1-КҮН', title: 'Процестерді қарау', desc: 'Демо және процестеріңізді талдау.' },
      { tag: '2–4-КҮН', title: 'Пилотты бастау', desc: 'Нақты көлікпен пилоттық жұмыс.' },
      { tag: '5–8-КҮН', title: 'Деректерді импорттау', desc: 'Жүргізушілер, көлік және анықтамалықтарды көшіру.' },
      { tag: '9–10-КҮН', title: 'Команданы оқыту', desc: 'Диспетчерлер мен жүргізушілерді оқыту.' },
      { tag: '11–12-КҮН', title: 'Іске қосу', desc: 'Толық қолдаумен өнеркәсіптік старт.' },
    ],
  },

  roi: {
    kicker: 'ҮНЕМДЕУ ӘЛЕУЕТІ',
    h2: 'LOGIXA автопаркіңізде нені өзгертеді.',
    fields: [
      { lbl: 'Көлік', unit: '' },
      { lbl: 'Жүргізушілер', unit: '' },
      { lbl: 'Айына тапсырыс', unit: '' },
      { lbl: 'Бір көлікке жылдық орташа жүріс', unit: 'км' },
    ],
    panelTitle: 'ЖЫЛДЫҚ ӘЛЕУЕТ',
    lines: ['Әкімшілік жұмыс азаяды', 'Бос жүріс оңтайландырылады', 'Отынды оңтайландыру'],
    totalLbl: 'Болжамды әлеует',
    basisLink: 'Есептеу негізін көрсету',
    basisClose: 'Есептеу негізін жасыру',
    basis: [
      'Әкімшілік: бір тапсырысқа 7,50 € (34 €/сағат мөлшерлемесінде шамамен 13 минут) және уақытты есепке алу мен жалақыны дайындауға айына бір жүргізушіге 15 €.',
      'Бос жүріс: бос километрлердің үлесі 18 %, оның 5 % жақсы диспетчерлеу арқылы болдырмауға болады, километріне 1,04 € шығын кезінде.',
      'Отын: 100 км-ге 30 л шығын және маршрут бойында жанармай құюды жоспарлау арқылы литріне 2 цент үнемдеу — Tankerkönig (DE), prix-carburants (FR), E-Control (AT) және MITECO (ES) нақты бағалары бойынша.',
      'Барлық көрсеткіштер — саладағы әдеттегі болжамдарға негізделген бағалау, кепілдендірілген үнемдеу емес.',
    ],
  },

  pricing: {
    kicker: 'БАҒАЛАР',
    h2: 'Ашық бағалар. Болжамды. Әділ.',
    sub: 'Автопаркіңізге сай тарифті таңдаңыз. Ай сайын бас тартуға болады.',
    allLink: 'Барлық бағалар',
    perMonth: '/ ай',
    badge: 'ҰСЫНЫЛАДЫ',
    cta: 'Демо сұрау',
    plans: [
      {
        name: 'STARTER', price: '€199', custom: false, scope: '15 көлікке дейін',
        features: ['Тапсырыстарды басқару', 'Жүргізуші қосымшасы', 'GPS бақылау', 'Email қолдау'],
      },
      {
        name: 'BUSINESS', price: '€499', custom: false, scope: '50 көлікке дейін',
        features: ['Starter мүмкіндіктерінің бәрі', 'AI диспетчер', 'Тахограф және EU 561', 'Басым қолдау'],
      },
      {
        name: 'ENTERPRISE', price: 'Жеке', custom: true, scope: '50-ден астам көлік',
        features: ['Business мүмкіндіктерінің бәрі', 'Кеңейтілген рұқсаттар', 'API және интеграциялар', 'Жеке менеджер'],
      },
    ],
    note: ['Шағын автопарктер арзанырақ бастайды: ', 'BASIC айына 49 €-дан', ' 3 көлікке дейін, ', 'DRIVER тегін', ' бір тартқышы бар жеке кәсіпкерлерге.'],
  },

  security: {
    title: 'Деректеріңіз Еуропада қалады.',
    items: ['Германиядағы хостинг', 'GDPR талаптарына сай', '2FA және Passkeys', 'Аудит журналдары', 'Сақтау кезіндегі шифрлау'],
  },

  faq: {
    kicker: 'FAQ',
    h2: 'TMS туралы жиі қойылатын сұрақтар.',
    sub: 'Сұрақтар қалды ма? Демода жауап береміз.',
    list: [
      {
        q: 'TMS жүйесі дегеніміз не?',
        a: 'Transport Management System тапсырыстарды өңдеуді, диспетчерлеуді, көлік пен жүргізушілерді басқаруды, құжаттар мен есеп айырысуды бір платформада біріктіреді — бөлек Excel кестелерінің, GPS порталдарының және бухгалтерлік бағдарламалардың орнына.',
      },
      {
        q: 'LOGIXA қандай компанияларға қолайлы?',
        a: '3-тен 50-ден астам көлікке дейінгі көлік және экспедиторлық компанияларға. Бір тартқышы бар жеке кәсіпкерлер тегін DRIVER тарифінен бастайды, шағын автопарктер — айына 49 €-дан BASIC, орта компаниялар — STARTER немесе BUSINESS.',
      },
      {
        q: 'LOGIXA Excel-ді алмастыра ала ма?',
        a: 'Иә. Тапсырыстар, жүргізушілер, көлік, анықтамалықтар және есеп айырысу шашыраңқы кестелердің орнына бір дерекқорда болады. Бар Excel және CSV файлдарын көшу кезінде тасымалдаймыз — өз деректеріңізбен бастайсыз.',
      },
      {
        q: 'Енгізу қанша уақыт алады?',
        a: 'Көшуді 12 күнге жоспарлаймыз: процестерді талдау, нақты көлікпен пилоттық жұмыс, деректерді импорттау, оқыту және іске қосу. Бұл кесте — біздің жұмыс тәртібіміз, клиенттік жобалар бойынша орташа көрсеткіш емес.',
      },
      {
        q: 'Қолданыстағы GPS-ті қалдыруға бола ма?',
        a: 'Көп жағдайда иә. LOGIXA қосымша жабдықсыз жүргізуші қосымшасы арқылы координаттарды алады және сонымен қатар бар жүйелерден телематика деректерін қабылдай алады. Сіздің жағдайыңызда қандай қосылым мүмкін екенін старт алдында анықтаймыз.',
      },
      {
        q: 'LOGIXA тахограф пен EU 561-ді қолдай ма?',
        a: 'EU 561 бойынша жүргізу және демалыс уақыты әр жүргізуші үшін үздіксіз есептеледі, асып кетуден бұрын ескертулермен. Тахографтың DDD файлдарын импорттап, қарауға болады; бұл өңдеу бақылаушы органдарға арналған ресми тахограф талдауы ретінде қарастырылмайды.',
      },
      {
        q: 'Жүргізушіге арналған қосымша бар ма?',
        a: 'Иә, iOS және Android үшін тоғыз тілдегі нативті қосымшалар: тапсырыс, навигация, құжат сканері, ePOD қолтаңбасы және рейсті жабу — офлайн да. Оған қоса қосымшасы жоқ жүргізушілер үшін Telegram бот бар.',
      },
      {
        q: 'LOGIXA-ны TIMOCOM және Trans.eu-мен байланыстыруға бола ма?',
        a: 'Коннекторлар дайындалған және құжатталған интерфейстер бойынша жазылған. Іске қосу сіздің жеке TIMOCOM немесе Trans.eu келісімшартыңыз арқылы жүреді; енгізу кезінде байланысты бірге баптап, сіздің қолжетімділіктеріңізбен тексереміз.',
      },
      {
        q: 'Деректер қайда сақталады?',
        a: 'Германиядағы серверлерде, GDPR талаптарына сай, тасымалдау және сақтау кезінде шифрланған. Қатынау журналданады, кіруді 2FA және Passkeys арқылы қорғауға болады.',
      },
      {
        q: 'LOGIXA қанша тұрады?',
        a: 'DRIVER бір тартқышы бар жеке кәсіпкерлерге тегін, BASIC 3 көлікке дейін айына 49 €-дан басталады, STARTER 15 көлікке дейін айына 199 €, BUSINESS 50 көлікке дейін айына 499 €. 50 көліктен астам болса жеке есептейміз. Барлық тарифтерден ай сайын бас тартуға болады.',
      },
    ],
  },

  finalCta: {
    h2: 'LOGIXA-ны өз көлік процестеріңізде көріңіз.',
    sub: '30 минуттық демода автопаркіңіз үшін маңызды модульдерді дәл көрсетеміз.',
    primary: 'Демо сұрау',
    secondary: 'Демо көру',
  },

  footer: {
    tagline: 'Еуропадағы көлік және экспедиторлық компанияларға арналған TMS жүйесі.',
    cols: [
      {
        title: 'ӨНІМ',
        links: [
          { label: 'Мүмкіндіктер', href: '/platform/funktionen' },
          { label: 'AI диспетчер', href: '/platform/ki' },
          { label: 'Жүргізуші қосымшасы', href: '/platform/funktionen#apps' },
          { label: 'Рейс жоспарлау', href: '/platform/funktionen#tourenplanung' },
          { label: 'Есеп айырысу', href: '/platform/backoffice' },
        ],
      },
      {
        title: 'ШЕШІМДЕР',
        links: [
          { label: 'Шағын компаниялар', href: '/pricing' },
          { label: 'Орта автопарктер', href: '/pricing' },
          { label: 'Халықаралық тасымал', href: '/platform/funktionen' },
          { label: 'Жеке жүргізушілер', href: '/pricing' },
        ],
      },
      {
        title: 'ИНТЕГРАЦИЯЛАР',
        links: [
          { label: 'TIMOCOM', href: '/platform/integrationen' },
          { label: 'Trans.eu', href: '/platform/integrationen' },
          { label: 'DATEV', href: '/platform/integrationen' },
          { label: 'Telegram', href: '/platform/integrationen' },
          { label: 'Барлық интеграциялар', href: '/platform/integrationen' },
        ],
      },
      {
        title: 'РЕСУРСТАР',
        links: [
          { label: 'Білім базасы', href: '/docs' },
          { label: 'Блог', href: '/blog' },
          { label: 'TMS дегеніміз не?', href: '/docs' },
          { label: 'TMS құны', href: '/pricing' },
          { label: 'Көмек орталығы', href: '/docs' },
        ],
      },
      {
        title: 'КОМПАНИЯ',
        links: [
          { label: 'Біз туралы', href: '/about' },
          { label: 'Мансап', href: '/jobs' },
          { label: 'Серіктестер', href: '/companies' },
          { label: 'Байланыс', href: '/kontakt' },
        ],
      },
    ],
    copyright: '© 2026 LOGIXA. Барлық құқықтар қорғалған.',
    legal: [
      { label: 'Құпиялылық', href: '/datenschutz' },
      { label: 'Импрессум', href: '/impressum' },
      { label: 'Шарттар', href: '/agb' },
      { label: 'Қауіпсіздік', href: '/platform/funktionen#sicherheit' },
    ],
  },
};
